/**
 * 🔑 API TOKENS SERVICE
 * 
 * Service para gerenciamento de tokens de API
 */

import axios from 'axios';
import { API_URL } from '../../config/api';

// Configurar axios com interceptors para token
const api = axios.create({
  baseURL: API_URL
});

// Interceptor para adicionar token em todas as requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor para tratar erros de resposta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('❌ Erro na API de tokens:', error);
    return Promise.reject(error);
  }
);

class ApiTokensService {
  /**
   * Criar novo token de API
   * 
   * @param {Object} data - Dados do token
   * @param {string} data.description - Descrição do token
   * @param {Object} data.permissions - Permissões granulares
   * @param {number} data.rate_limit_per_minute - Limite por minuto
   * @param {number} data.rate_limit_per_hour - Limite por hora
   * @param {string[]} data.ip_whitelist - Lista de IPs permitidos
   * @param {string} data.expires_at - Data de expiração ISO
   */
  async createToken(data) {
    const response = await api.post('/api/v1/tokens', data);
    return response.data;
  }

  /**
   * Listar tokens do usuário
   */
  async getTokens() {
    const response = await api.get('/api/v1/tokens');
    return response.data;
  }

  /**
   * Buscar token por ID
   * 
   * @param {number} tokenId - ID do token
   */
  async getTokenById(tokenId) {
    const response = await api.get(`/api/v1/tokens/${tokenId}`);
    return response.data;
  }

  /**
   * Atualizar token
   * 
   * @param {number} tokenId - ID do token
   * @param {Object} data - Dados a atualizar
   */
  async updateToken(tokenId, data) {
    const response = await api.put(`/api/v1/tokens/${tokenId}`, data);
    return response.data;
  }

  /**
   * Revogar token
   * 
   * @param {number} tokenId - ID do token
   */
  async revokeToken(tokenId) {
    const response = await api.delete(`/api/v1/tokens/${tokenId}`);
    return response.data;
  }
}

const apiTokensService = new ApiTokensService();
export default apiTokensService;

